import { VuexModule, mutation, Module, action } from 'vuex-class-component';

@Module({ namespacedPath: 'common/' })
export class CommonStore extends VuexModule {
    // ローディング状態
    private _loading_state: boolean = false;
    get loading_state() {
        return this._loading_state;
    }
    @mutation
    private setLoadingState(value: boolean) {
        this._loading_state = value;
    }
    @action
    public async setLoadingStateAc(value: boolean) {
        this.setLoadingState(value);
    }

    // Alert
    private _alert_params: {
        is_display: boolean; // 表示フラグ
        type: string; // タイプ
        timeout: number; // 表示時間
        message: string; // メッセージ
        return_flg: boolean; // ログイン画面に戻すフラグ
    } = {
        is_display: false,
        type: 'white',
        timeout: -1,
        message: '',
        return_flg: false,
    };
    get alert_params() {
        return this._alert_params;
    }
    @mutation
    private setAlertParams(value: any) {
        this._alert_params = value;
    }
    @action
    public async setAlertParamsAc(value: any) {
        this.setAlertParams(value);
    }

    // 初期化
    @action
    public async initializeParamAc() {
        this.setLoadingState(false);
        this.setAlertParams({
            is_display: false,
            type: 'white',
            timeout: -1,
            message: '',
            return_flg: false,
        });
    }
}
